<template>
  <transition name="m-fade">
    <div class="nav-background" @click="hide" v-show="isShow">
      <div class="nav-box" @click.stop>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>


<script>
  export default {
    props: {
      code: {
        type: String
      }
    },
    data () {
      return {
        isShow: false
      }
    },
    created () {
      this.$root.$on('openNav', code => {
        this.isShow = (code === this.code)
      })
      this.$root.$on('closeAllNav', () => {
        this.isShow = false
      })
    },
    methods: {
      hide () {
        this.isShow = false
      }
    }
  }
</script>


<style scoped lang="scss">
  .nav-background{
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    display: flex;
    justify-content: center;
  }
  .nav-box {
    position: absolute;
    top: 88px;
    width: 90%;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    padding: 16px;
    background-color: $color-header-background;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/MNav.vue